import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { DurchsuchenService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [DurchsuchenService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class DurchsuchenServiceModule {}
